module.exports = __webpack_public_path__ + "static/media/IELTS_exam.e7279acf.png";